import {Directive} from "@angular/core";
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors} from "@angular/forms";
import {Observable} from "rxjs";
import {PortableRegistrationService} from "../services/portable-registration.service";

@Directive({
	selector: "[validPortableDevice][formControlName], [validPortableDevice][formControl], [validPortableDevice][ngModel]",

	// We add our directive to the list of existing validators
	providers: [
		{provide: NG_ASYNC_VALIDATORS, useExisting: PortableDeviceValidator, multi: true},
	],
})

export class PortableDeviceValidator implements AsyncValidator {

	constructor(private portableRegistrationService: PortableRegistrationService) {}

	// This method is the one required by the AsyncValidator interface
	validate(control: AbstractControl):  Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {

		let debounceTime = 1500; // milliseconds, should be equal to portable-registration-form's productSearchDebounceSecondsMilli
		return Observable.timer(debounceTime).switchMap(() => {
			return this.portableRegistrationService.getPortableDevicesBySerialNumber(control.value).map(
				portable => {
					return portable ? null : {serialNumber: "Portable device not found"};
				},
				() => {
					return {serialNumber: "Serial number invalid"};
				},
			);
		});
	}
}

